import { cn } from '@/lib/utils'

type Props = {
  children: React.ReactNode
  className?: string
  id?: string
}
export const CareAndShareContainer: React.FC<Props> = ({
  children,
  className,
  ...props
}) => {
  return (
    <section
      className={cn('px-4 py-10 lg:px-16 lg:py-20', className)}
      {...props}
    >
      {children}
    </section>
  )
}
